class Owner {
  constructor(client) {
    this.client = client
  }

  get(options) {
    return this.client._request({
      method: 'GET',
      path: '/owners/v2/owners',
      qs: options,
    })
  }

  getById(id, options) {
    return this.client._request({
      method: 'GET',
      path: '/owners/v2/owners/' + id,
      qs: options,
    })
  }
}

module.exports = Owner



//////////////////
// WEBPACK FOOTER
// ./~/hubspot/lib/owner.js
// module id = uzVE
// module chunks = 1